var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasOfferItems
    ? _c(
        "div",
        { staticClass: "offer-item" },
        [
          _c("div", { staticClass: "offer-info" }, [
            _c("div", { staticClass: "offer-name" }, [
              _vm._v(_vm._s(_vm.offer.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offer-description" }, [
              _vm._v(_vm._s(_vm.offer.description))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "offer-add-text" }, [
            _vm._v("\n\t\tChoose item to add offer:\n\t")
          ]),
          _vm._v(" "),
          _c("menu-item-rows", {
            attrs: {
              items: _vm.getOfferItems(_vm.offer),
              afterClick: _vm.autoApplyOffer
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dd7f2fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd7f2fc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/OfferCouponItem.vue
// module id = null
// module chunks = 